import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../config.service';
import { LocalStorageService } from '../storage.service';
import { BusinessContextService } from '../business-context.service';
import { MenuProductOption } from '../../models/menu-product-option.model';

@Injectable({
  providedIn: 'root',
})
export class MenuProductOptionService {
  private readonly URL: string;
  private readonly CUSTOMER: string;

  constructor(
    private readonly http: HttpClient,
    private readonly config: ConfigService,
    private readonly localStorageService: LocalStorageService,
    private readonly bizCtx: BusinessContextService,
  ) {
    this.URL = this.config.apiUrl;
    this.CUSTOMER = this.config.customer;
  }

  private getBusiness(): string {
    return this.bizCtx.getSelected() || this.CUSTOMER;
  }

  getOptions(menuProductUuid: string): Observable<MenuProductOption[]> {
    const business = this.getBusiness();
    return this.http.get<MenuProductOption[]>(`${this.URL}/menu-product/${business}/${menuProductUuid}/options`);
  }

  createOption(menuProductUuid: string, option: Omit<MenuProductOption, 'uuid' | 'menuProductUuid'>): Observable<MenuProductOption> {
    const business = this.getBusiness();
    return this.http.post<MenuProductOption>(`${this.URL}/menu-product/${business}/${menuProductUuid}/options`, option);
  }

  updateOption(menuProductUuid: string, optionUuid: string, option: Partial<MenuProductOption>): Observable<MenuProductOption> {
    const business = this.getBusiness();
    return this.http.put<MenuProductOption>(`${this.URL}/menu-product/${business}/${menuProductUuid}/options/${optionUuid}`, option);
  }

  deleteOption(menuProductUuid: string, optionUuid: string): Observable<void> {
    const business = this.getBusiness();
    return this.http.delete<void>(`${this.URL}/menu-product/${business}/${menuProductUuid}/options/${optionUuid}`);
  }

  // Bulk create options for a MenuProduct
  // Endpoint: POST /api/v1/menu-product/:businessUuid/:menuProductUuid/options/bulk
  // Body: Array<{ name: string; priceDelta: number; enabled: boolean; sortOrder: number }>
  createOptionsBulk(
    menuProductUuid: string,
    options: Array<Omit<MenuProductOption, 'uuid' | 'menuProductUuid'>>
  ): Observable<MenuProductOption[]> {
    const business = this.getBusiness();
    const url = `${this.URL}/menu-product/${business}/${menuProductUuid}/options/bulk`;
    return this.http.post<MenuProductOption[]>(url, options);
  }
}
